import React from 'react';
import { navItems } from '../data/portfolio';
export function SiteNav() {
  return <nav aria-label="Section navigation" className="sticky top-0 z-50 border-b border-white/10 bg-ink/95 backdrop-blur-sm" data-id="element-206" data-mp="3fe94vvy623uc">
      <div className="mx-auto flex w-full max-w-edge items-center justify-between gap-8 px-6 py-5 md:px-10" data-id="element-207" data-mp="3aly12i0b1xwi">
        <a href="#top" className="shrink-0 text-[11px] font-medium uppercase tracking-[0.34em] text-paper transition-colors duration-150 ease-editorial hover:text-brass" data-id="element-208" data-mp="35nmrm8dx9pet">
          Nigel Grierson
        </a>
        <ul className="-mx-3 flex items-center gap-6 overflow-x-auto px-3" data-id="element-209" data-mp="2roetzjxeqpcq">
          {navItems.map(item => <li key={item.href} className="shrink-0" data-id="element-210" data-mp="2mptq9aiy5njj">
              <a href={item.href} className="block whitespace-nowrap py-1 text-[11px] font-medium uppercase tracking-[0.24em] text-fog transition-colors duration-150 ease-editorial hover:text-paper focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-brass" data-id="element-211" data-mp="2mr4wri3s19ec">
                {item.label}
              </a>
            </li>)}
        </ul>
      </div>
    </nav>;
}